(() => {
  const initBuyBar = (bar) => {
    if (bar.dataset.initialized === 'true') return;

    const sectionId = bar.dataset.sectionId;
    const productInfo = bar.closest('product-info');
    const originalButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const mobileButton = bar.querySelector('[data-wntn-mobile-buy-button]');
    const mobilePrice = bar.querySelector('[data-wntn-mobile-buy-price]');
    const priceContainer = document.getElementById(`price-${sectionId}`);
    const volumeTotal = productInfo?.querySelector('[data-volume-tier-total]');

    if (!productInfo || !originalButton || !mobileButton) return;

    bar.dataset.initialized = 'true';
    let originalButtonVisible = false;

    const sync = () => {
      const originalLabel = originalButton.querySelector('span')?.textContent?.trim();
      const activePrice = productInfo.querySelector(
        `#price-${sectionId} .price-item--sale, #price-${sectionId} .price-item--regular`
      );
      const volumeTotalText = volumeTotal?.textContent?.trim().replace(/^Gesamtpreis:\s*/i, '');

      mobileButton.disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
      mobileButton.textContent = originalLabel || 'In den Warenkorb legen';
      if (mobilePrice && (volumeTotalText || activePrice)) {
        mobilePrice.textContent = volumeTotalText || activePrice.textContent.trim();
      }
      bar.hidden = originalButtonVisible;
    };

    mobileButton.addEventListener('click', () => {
      if (!mobileButton.disabled) originalButton.click();
    });

    new IntersectionObserver(
      ([entry]) => {
        originalButtonVisible = entry.isIntersecting;
        sync();
      },
      { threshold: 0.2 }
    ).observe(originalButton);

    new MutationObserver(sync).observe(originalButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });

    if (priceContainer) {
      new MutationObserver(sync).observe(priceContainer, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    if (volumeTotal) {
      new MutationObserver(sync).observe(volumeTotal, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    sync();
  };

  const init = () => document.querySelectorAll('[data-wntn-mobile-buy-bar]').forEach(initBuyBar);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
